export const cast_crew_data = [
  {
    name: "Jelani Cobb",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/ltl1gmFGw96zPqSCXoT1pJoV0Z4.jpg",
  },
  {
    name: "Hans Charles",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/uW3Rv7DM843Jpoy7SfqygcPXPHW.jpg",
  },
  {
    name: "Angela Davis",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/rCGiP5iycqFodkrxslZl19IsIcf.jpg",
  },
  {
    name: "Henry Louis Gates, Jr.",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/g30YwBCefnlIBXnvXKV3A8Z3Fly.jpg",
  },
  {
    name: "Michelle Alexander",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/af2ybpGlXZgUfm2axcJh80nEGTp.jpg",
  },
  {
    name: "David Oyelowo",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/7UZHRwOKe2cYxj8SeNUklyPYkns.jpg",
  },
  {
    name: "Oprah Winfrey",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/nNpYieaDLxKZWw2FY9wsDkjwURu.jpg",
  },
  {
    name: "Cory Booker",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/qbs1ZFOQK8iTZmYuB94gVkaNbvM.jpg",
  },
  {
    name: "Oprah Winfrey",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/nNpYieaDLxKZWw2FY9wsDkjwURu.jpg",
  },
  {
    name: "Marie Gottschalk",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/q18irjqb0RV1P2j5OytV8pWOPY5.jpg",
  },
  {
    name: "Ava DuVernay",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/84rc8I3Wf5zkCWGMNeTtmRekHW0.jpg",
  },
  {
    name: "Barack Obama",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/lh6KOxZiM90jk2swWpsRB0UxTW0.jpg",
  },
  {
    name: "Bill Clinton",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/aOSAwUHkTYdcVrl5MdOzuGRluTm.jpg",
  },
  {
    name: "Jimmy Carter",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/pE5rS9UcWwitwf3g2sBTJudjls2.jpg",
  },
  {
    name: "George W. Bush",
    "img-src":
      "https://www.themoviedb.org/t/p/w132_and_h132_face/6u9fUB5p0ugbMrPoQ5GF7baERiA.jpg",
  },
];
